import bigBassBonanza from './img/big-bass-bonanza.gif';
import bookOfKingdoms from './img/book-of-kingdoms.gif';
import christmassCarolMegaways from './img/christmas-carol-megaways.gif';
import congoCash from './img/congo-сash.gif';
import cowboysGold from './img/cowboys-gold.gif';
import dragonKingdoms from './img/dragon-kingdom-eyes-of-fire.gif';
import emeralKingRainbowRoad from './img/emerald-king-rainbow-road.gif';
import eyeOfTheStorm from './img/eye-of-the-storm.gif';
import fishinReels from './img/fishin-reels.gif';
import gatesOfOlympus from './img/gates-of-olympus.gif';
import hotToBurnHoldAndSpin from './img/hot-to-burn-hold-and-spin.gif';
import johnHunterAndTheMayanGods from './img/john-hunter-and-the-mayan-gods.gif';
import jokerKing from './img/joker-king.gif';
import juicyFruits from './img/juicy-fruits.gif';
import madameDestinyMegaways from './img/madame-destiny-megaways.gif';
import mysteriousEgypt from './img/mysterious-egypt.gif';
import pirateGoldDeluxe from './img/pirate-gold-deluxe.gif';
import powerOfThorMegaways from './img/power-of-thor-megaways.gif';
import spartanKing from './img/spartan-king.gif';
import temujinTreasures from './img/temujin-treasures.gif';
import theHandOfMidas from './img/the-hand-of-midas.gif';
import voodooMagic from './img/voodoo-magic.gif';
import wildBooster from './img/wild-booster.gif';
import lions5 from './img/5-lions.gif';
import ancientEgyp from './img/ancient-egyp.gif';
import asgard from './img/asgard.gif';
import aztecGems from './img/aztec-gems.gif';
import chilliHeat from './img/chilli-heat.gif';
import daVincisTreasure from './img/da-vincis-treasure.gif';
import diamondStrike from './img/diamond-strike.gif';
import fairytaleFortune from './img/fairytale-fortune.gif';
import fire88 from './img/fire-88.gif';
import goldRush from './img/gold-rush.gif';
import greatRhino from './img/great-rhino.gif';
import jadeButterfly from './img/jade-butterfly.gif';
import jokersJewels from './img/jokers-jewels.gif';
import leprechaunSong from './img/leprechaun-song.gif';
import luckyNewYear from './img/lucky-new-year.gif';
import madamDestiny from './img/madame-destiny.gif';
import masterChensFortune from './img/master-chens-fortune.gif';
import monkeyMmadness from './img/monkey-madness.gif';
import pekingLuck from './img/peking-luck.gif';
import roulette from './img/roulette.gif';
import theChampions from './img/the-champions.gif';
import tripleTigers from './img/triple-tigers.gif';
import vegasMagic from './img/vegas-magic.gif';
import monkeys7 from './img/7-monkeys.gif';
import aladdinsTreasure from './img/aladdins-treasure.gif';
import diamondsAreForever3Lines from './img/diamonds-are-forever-3-lines.gif';
import dwarvenGold from './img/dwarven-gold.gif';
import dwarvenGoldDeluxe from './img/dwarven-gold-deluxe.gif';
import gloriousRome from './img/glorious-rome.gif';
import greatReef from './img/great-reef.gif';
import hockeyLeague from './img/hockey-league.gif';
import hockeyLeagueWildMatch from './img/hockey-league-wild-match.gif';
import journeyToTheWest from './img/journey-to-the-west.gif';
import ladyGodiva from './img/lady-godiva.gif';
import ladyOfTheMoon from './img/lady-of-the-moon.gif';
import luckyDragons from './img/lucky-dragons.gif';
import magicCrystals from './img/magic-crystals.gif';
import mightyKong from './img/mighty-kong.gif';
import multihandBlackjack from './img/multihand-blackjack.gif';
import romeoAndJuliet from './img/romeo-and-juliet.gif';
import talesOfEgypt from './img/tales-of-egypt.gif';
import theCatfather from './img/the-catfather.gif';
import theCatfatherPartII from './img/the-catfather-part-II.gif';
import dragons8 from './img/8-dragons.gif';
import gold888 from './img/888-gold.gif';
import caishensGold from './img/caishens-gold.gif';
import dragonKingdom from './img/dragon-kingdom.gif';
import goldTrain from './img/gold-train.gif';
import herculesSonOfZeus from './img/hercules-son-of-zeus.gif';
import hotSafari from './img/hot-safari.gif';
import irishCharms from './img/irish-charms.gif';
import jurassicGiants from './img/jurassic-giants.gif';
import pandasFortune from './img/pandas-fortune.gif';
import pantherQueen from './img/panther-queen.gif';
import pixieWings from './img/pixie-wings.gif';
import queenOfAtlantis from './img/queen-of-atlantis.gif';
import queenOfGold from './img/queen-of-gold.gif';
import santa from './img/santa.gif';
import vegasNights from './img/vegas-nights.gif';
import wildSpells from './img/wild-spells.gif';
import wolfGold from './img/wolf-gold.gif';
import genieWishes3 from './img/3-genie-wishes.gif';
import kingdomsBattleOfRedCliffs3 from './img/3-kingdoms-battle-of-red-cliffs.gif';
import piggies7 from './img/7-piggies.gif';
import dragons888 from './img/888-dragons.gif';

export const animatedIcons: {
  [key: string]: string;
} = {
  vs10bbbonanza: bigBassBonanza, // big bass bonanza
  vs25bkofkngdm: bookOfKingdoms, // book of kingdoms
  vs20xmascarol: christmassCarolMegaways, // christmass carol megaways
  vs432congocash: congoCash, // congo сash
  vs10cowgold: cowboysGold, // cowboys gold
  vs5drmystery: dragonKingdoms, // dragon kingdom eyes of fire
  vs20ekingrr: emeralKingRainbowRoad, // emerald king rainbow road
  vs10eyestorm: eyeOfTheStorm, // eye of the storm
  vs10goldfish: fishinReels, // fishin reels
  vs20olympgate: gatesOfOlympus, // gates of olympus
  vs20hburnhs: hotToBurnHoldAndSpin, // hot to burn hold and spin
  vs10mayangods: johnHunterAndTheMayanGods, // john hunter and the mayan gods
  vs25jokerking: jokerKing, // joker king
  vs50juicyfr: juicyFruits, // juicy fruits
  vswaysmadame: madameDestinyMegaways, // madame destiny megaways
  vs10wildtut: mysteriousEgypt, // mysterious egypt
  vs40pirgold: pirateGoldDeluxe, // pirate gold deluxe
  vswayshammthor: powerOfThorMegaways, // power of thor megaways
  vs40spartaking: spartanKing, // spartan king
  vs1024temuj: temujinTreasures, // temujin treasures
  vs20midas: theHandOfMidas, // the hand of midas
  vs40voodoo: voodooMagic, // voodoo magic
  vs20wildboost: wildBooster, // wild booster
  vs243lions: lions5, // 5 lions
  vs10egypt: ancientEgyp, // ancient egyp
  vs25asgard: asgard, // asgard
  vs5aztecgems: aztecGems, // aztec gems
  vs25chilli: chilliHeat, // chilli heat
  vs25davinci: daVincisTreasure, // da vinci's treasure
  vs15fairytale: fairytaleFortune, // fairytale fortune
  vs7fire88: fire88, // fire 88
  vs25goldrush: goldRush, // gold rush
  vs20rhino: greatRhino, // great rhino
  vs1024butterfly: jadeButterfly, // jade butterfly
  vs5joker: jokersJewels, // joker's jewels
  vs20leprechaun: leprechaunSong, // leprechaun song
  vs25newyear: luckyNewYear, // lucky new year
  vs10madame: madamDestiny, // madam destiny
  vs9chen: masterChensFortune, // master chen's fortune
  vs9madmonkey: monkeyMmadness, // monkey madness
  vs25peking: pekingLuck, // peking luck
  rla: roulette, // roulette
  vs25champ: theChampions, // the champions
  vs1tigers: tripleTigers, // triple tigers
  vs20vegasmagic: vegasMagic, // vegas magic,
  vs7monkeys: monkeys7, // 7 monkeys
  vs50amt: aladdinsTreasure, // aladdin's treasure
  cs3w: diamondsAreForever3Lines, // diamonds are forever 3 lines
  vs25dwarves: dwarvenGold, // dwarven gold
  vs25dwarves_new: dwarvenGoldDeluxe, // dwarven gold deluxe
  vs20rome: gloriousRome, // glorious rome
  vs25sea: greatReef, // great reef
  vs20hockey: hockeyLeague, // hockey league
  vs9hockey: hockeyLeagueWildMatch, // hockey league wild match
  vs25journey: journeyToTheWest, // journey to the west
  vs20godiva: ladyGodiva, // lady godiva
  vs13ladyofmoon: ladyOfTheMoon, // lady of the moon
  vs50chinesecharms: luckyDragons, // lucky dragons
  vs243crystalcave: magicCrystals, // magic crystals
  vs50kingkong: mightyKong, // mighty kong
  bjma: multihandBlackjack, // multihand blackjack
  vs25romeoandjuliet: romeoAndJuliet, // romeo and juliet
  vs20egypt: talesOfEgypt, // tales of egypt
  vs9catz: theCatfather, // the catfather
  vs30catz: theCatfatherPartII, // the catfather part II
  vs20eightdragons: dragons8, // 8 dragons
  cs5triple8gold: gold888, // 888 gold
  vs243fortune: caishensGold, // caishen's gold
  vs15diamond: diamondStrike, // diamond strike
  vs25dragonkingdom: dragonKingdom, // dragon kingdom
  vs3train: goldTrain, // gold train
  vs50hercules: herculesSonOfZeus, //  hercules son of zeus
  vs25safari: hotSafari, // hot safari
  cs3irishcharms: irishCharms, // irish charms
  vs4096jurassic: jurassicGiants, // jurassic giants
  vs25pandagold: pandasFortune, // pandas fortune
  vs25pantherqueen: pantherQueen, // panther queen
  vs50pixie: pixieWings, // pixie wings
  vs1024atlantis: queenOfAtlantis, // queen of atlantis
  scqog: queenOfGold, // queen of gold
  vs20santa: santa, // santa
  vs25vegas: vegasNights, // vegas nights
  vs25wildspells: wildSpells, // wild spells
  vs25wolfgold: wolfGold, // wolf gold
  vs50aladdin: genieWishes3, // 3 genie wishes
  vs25kingdomsnojp: kingdomsBattleOfRedCliffs3, // 3 kingdoms battle of red cliffs
  vs7pigs: piggies7, // 7 piggies
  vs1dragon8: dragons888, // 888 dragons
};
